import { createSlice } from "@reduxjs/toolkit";
import {
    CreateOrEditHorseLeasethunk,
    ApproveRejectHorseLeasethunk
} from "./horseLeasingAction";

const initialState = {
    isLoading: false,
    leaseRequestData: null,
    covCerByHorseIdData: null,
    toasterMessage: null,
    error: null,
};

const horseLeasingSlice = createSlice({
    name: "horseLeasing",
    initialState,
    reducers: {
        resetToasterMessage: (state) => {
            state.toasterMessage = null;
        },
        resetLeaseRequestData: (state) => {
            state.leaseRequestData = null;
        },
        resetCovCerData: (state) => {
            state.covCerByHorseIdData = null;
        }
    },
    extraReducers: (builder) => {
        // CreateOrEdit
        builder.addCase(CreateOrEditHorseLeasethunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(CreateOrEditHorseLeasethunk.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action.payload?.status?.responseCode === "100") {
                state.toasterMessage = action.payload.status.detailedResponseCode || "error";
            } else {
                state.toasterMessage = "save";
            }
        });
        builder.addCase(CreateOrEditHorseLeasethunk.rejected, (state, action) => {
            state.isLoading = false;
            state.toasterMessage = action.payload || "error";
        });

        // ApproveReject
        builder.addCase(ApproveRejectHorseLeasethunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(ApproveRejectHorseLeasethunk.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action.payload?.status?.responseCode === "100") {
                state.toasterMessage = action.payload.status.detailedResponseCode || "error";
            } else {
                state.toasterMessage = "save";
            }
        });
        builder.addCase(ApproveRejectHorseLeasethunk.rejected, (state, action) => {
            state.isLoading = false;
            state.toasterMessage = action.payload || "error";
        });

    },
});

export const { resetToasterMessage, resetLeaseRequestData, resetCovCerData } = horseLeasingSlice.actions;
export default horseLeasingSlice.reducer;
